<template>
  <div class="disable-overlay" />
</template>

<script>
export default {
  name: 'MainSidebarDisabledOverlay'
}
</script>

<style scoped lang="scss">
.disable-overlay {
  position: absolute;
  inset: 0;
  z-index: 9999;
  background: transparent;
  pointer-events: all;
  cursor: not-allowed;
}
</style>
